// extracted by mini-css-extract-plugin
export var card = "_s2-0";